import { 
    Navigate, 
    Outlet 
} from "react-router-dom";
import { useAuth } from "../../lib/hooks";

export default function RequireUnauth() {
    const authenicated = useAuth();
    
    return (
        authenicated
            ? <Navigate to="/" replace />
            : <Outlet/>
    )
}